import React from 'react';
import useFileDownloader from 'hooks/useFileDownloader';
import { getACGSignedUrl } from 'services/acg/utils';
import DownloadButtonRound from '../../../components/ui/DownloadButtonRound';

type Props = {
  gcsPath: string,
  filename: string,
  phase?: 'phase1' | 'phase2',
};

export default function FilenameWithDownloader(props: Props) {
  const { handleDownload, loading } = useFileDownloader({
    file: { id: props.gcsPath },
    getSignedUrl: id => getACGSignedUrl(id, props.phase),
    queryKey: 'acg-signed-url',
  });
  return (
    <div className="flex items-center space-x-2">
      <DownloadButtonRound loading={loading} onClick={handleDownload} />
      <div
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {props.filename}
      </div>
    </div>
  );
}
